export default __webpack_public_path__ + "static/mobx-1d6179a0203fd55f43cf41e9a8d5212c.svg";